export type Uint64 = number; // bigint ?
export type DVMString = string;
export type Hash = string;
export type SCCode = string;
export type Address = string;
export type DataType = "S" | "U" | "H";

export type Stringkeys = { [key: string]: number | string };

export type Entity = "wallet" | "daemon";

export type Config = {
  address?: string;
  port?: number;
  debug?: boolean;
  timeout?: {
    AUTH_TIMEOUT?: number;
    METHOD_TIMEOUT?: number;
    BLOCK_TIMEOUT?: number;
  };
  secure?: boolean;
};

export enum ConnectionState {
  Initializing = "initializing",
  WaitingAuth = "waitingAuth",
  Accepted = "accepted",
  Refused = "refused",
  Closed = "closed",
}

export type AppInfo = {
  //! security threat => token based communication (generated by wallet)
  id: string; //TODO
  name: string;
  description: string;
  url?: string;
};

export type EventType = "new_topoheight" | "new_entry" | "new_balance";
